module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('Promo_OurSites', {
		configure: function(options) {
			this.filterFields = [
				'mcpSubscription_niches_siteNicheId',
				'mcpSubscription_contentCategories_contentCategoryId',
				'mcpSubscription_interactionFeatures_interactionFeatureId',
				'mcpSubscription_data_restrictionTagId'
			];
			this.registerOptions('', {
				template: 'promo_oursite_page',
				widgets: {
					signupForm: {
						widget: 'Home_Registration'
					},
					warningPopup: {
						widget: 'Dialog',
						template: 'same_account',
						dialog: {
							autoOpen: options.autoOpen || false,
							dialogClass: 'dlg-amc dark-overlay',
							title: 'ERROR',
							closeText: '',
							width: 'auto'
						},
						handleWom: {
							dOnShow: {
								event: 'show',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).addClass('blured');
								}
							},
							dOnHide: {
								event: 'hide',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
								}
							}
						}
					},

					sitesDatalayer: {
						widget: 'Datalayer',
						method: 'Partner_McProfits.getModels',
						fields: ['mcpSubscription._avatar', 'site.domain', 'clientId.name'],
						metaFields: {
							'totalCount': 1,
							'mcpSubscription.avatar': 1
						},
						limit: 24
					},

					ourSites:{
						widget: 'Grid',
						dl: '@parent #sitesDatalayer',
						externalLoad: true,
						template: 'grid_models',
						container: '.grid-models',
						list: {
							'tpl.row': 'our_sites_model',
							container: '.list-models',
							'tpl.emptyRow': 'our_sites_model_empty_item'
						},
						pager: {
							widget: 'ContentPager',
							'embed.container': '.content-pager',
							ignoreActivate: false,
							navigatorPrefix: 'page'
						}
					},

					preloader: {
						widget: 'PromisePreloader',
						'embed.container': '.list-models',
						'embed.widget': '@parent #ourSites'
					},

					filter: {
						widget: 'AdvancedFilter_ModelsFilter',
						template: 'models_advanced_filter',
						'!embed.container': '.filter-models'
					}
				},
				handleWom: {
					applyFilters: {
						widget: '#filter',
						event: 'apply',
						callback: 'applyFilters'
					}
				},
				handleDom: {
					gradeClick: {
						target: 'label.btn',
						event: 'click',
						targetWidget: '#filter',
						callback: 'checkboxGroup'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activate: function() {
			this.callParent('activate', arguments);
			this.dlExternalLoad();
		},

		running: function () {
			this.callParent('running', arguments);
			this.dlExternalLoad();
		},

		dlExternalLoad: function() {
			var externalLoad = false;
			fox.each(fox.Navigator.getAll(), function(val, key) {
				if (!fox.isNumeric(key)) {
					externalLoad = true;
				} 
			}, this);

			if (!externalLoad) {
				this.rwom1('#preloader').show(this.wom1('#sitesDatalayer').load());
			}
		},

		_checkFilterValue: function (val) {

			if (fox.isArray(val)) {
				return val.length > 0;
			}

			if (fox.isString(val)) {
				if (fox.isNumeric(val)) {
					return (window.parseInt(val) > 0);
				}

				return val.length > 0;
			}

			return val;
		},

		applyFilters: function (filters) {
			
			var page = this.getFilterValue('page');
			var w = this.wom1('#ourSites');
			w.dl.clearAllFilters();
			var pagerPage = page ? w.dl.setCp(page) : w.dl.setCp(1);

			// if (fox.isEmpty(filters)) {
			// 	return;
			// }

			w.dl.addFilter('project', {fields: ['mcpSubscription.project'], values: [1]});
			fox.each(this.filterFields, function (alias) {
				var fAlias = alias.replace(/\_/g, '.');
				var val = this.getFilterValue(alias);

				var prefix = fox.isArray(val) ? '' : '~';
				var values = fox.isArray(val) ? [val] : ['%' + val + '%'];
				
				if (this._checkFilterValue(val)) {
					console.log(prefix + fAlias, values);
					w.dl.addFilter(fAlias, {fields: [prefix + fAlias], values: values});
				}
			}, this);

			this.rwom1('#preloader').show(w.dl.load());
		},

		getFilterValue: function (filter) {
			var val;
			var values = this.wom1('#filter').filters;

			if (values[filter]) {
				val = values[filter];
			}

			return val;
		},

	
		switchStateMenu: function(name, type) {
			$('#promo-header .menu-link').removeClass('active');
			$('#promo-header .menu-link[data-name="' + name + '"]').toggleClass('active', type);
		},

		resetStateMenus: function() {
			$('#promo-header .menu-link').removeClass('active');
		},

		subscribeFormNotValid: function(res) {
			var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

			througthNotifications.pushNotification({
				noticeTemplate: 'new_notice',
				noticeType: 'error',
				noticeMessage: res.msg,
				noticeAlias: 'subscribeFieldNotValid',
				listenWidgetDeactivate: this,
				delayClose: 3000
			});
		},

		subscribeFormSubmit: function() {
			var form = this.wom1('#subscribeForm');
			form.submit();
			form.ignoreSubmit(true);
		},

		subscribeFormIsSubmitted: function(response, type) {
			var form = this.wom1('#subscribeForm');
			
			if (response.answer.answer.status) {
				var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

				througthNotifications.pushNotification({
					noticeTemplate: 'new_notice',
					noticeType: 'success',
					noticeMessage: 'You have successfully subscribed to the Newsletter!',
					noticeAlias: 'subscribeSuccess',
					listenWidgetDeactivate: this,
					delayClose: 3000
				});

				form.resetForm();
			}

			form.ignoreSubmit(false);
		},

		checkboxGroup: function(el) {
			var elem = $(el).prev();
			var currentCheck = $(elem).prop("checked");
			var group = "input:checkbox[name='mcpSubscription_data_restrictionTagId']";
			$(group).prop("checked",false);
			$(elem).prop("checked", currentCheck);
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/oursites/oursites.js
// module id = 209
// module chunks = 5